import { EDITREMINDER_SUCCESS, EDITREMINDER_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const editReminderReducer = (state = initialState, action) => {
    switch (action.type) {
        case EDITREMINDER_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case EDITREMINDER_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }
    return state;
};

export default editReminderReducer;
